export const findParent = (element: any, findFn: any): any => {
    if (!element || !findFn) {
        return null;
    }
    if (findFn(element)) {
        return element;
    } else if (element.parentNode && element.parentNode.tagName.toLowerCase() !== 'body') {
        return findParent(element.parentNode, findFn);
    }
    return null;
};
